export default __webpack_public_path__ + "static/media/helloar_logo.876b7bc0.svg";